import Forfait from 'assets/img/forfaits.png';
import MainDoeuvre from 'assets/img/main-doeuvre.png';
import RideauMetallique from 'assets/img/rideau-metallique.png';
import StoreBanne from 'assets/img/store-banne.png';
// import VoletIcone from "assets/img/volet-icone.svg";
import VoletRoulant from 'assets/img/volet-roulant.png';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import voletRoulant from './voletRoulant';
// import RideauMetalliqueData from './rideauMetallique';
// import StoreBanneData from './Storebanne';
import PortailData from 'constants/simulatorDataFacile/Portail';
import RideauMetalliqueData from 'constants/simulatorDataDetails/rideauMetallique';
import PorteGarageData from './PorteGarage';
import StoreBanneData from './Storebanne';
import StoreData from './Store';
import Porte from 'assets/img/porte-basculante.png';

import Portail from 'assets/img/portail.png';

const simulatorData = {
	id: 'SP',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sélectionner une catégorie',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	options: [
		{
			id: 'VR',
			label: 'Volet Roulant',
			value: 'VR',
			imageUrl: VoletRoulant,
			nextStep: voletRoulant,
		},
		{
			id: 'RM',
			label: 'Rideau métallique',
			value: 'RM',
			imageUrl: RideauMetallique,
			nextStep: RideauMetalliqueData,
		},
		{
			id: 'SB',
			label: 'Store',
			value: 'SB',
			imageUrl: StoreBanne,
			nextStep: StoreData,
		},
		{
			id: 'pe',
			label: 'Portail électrique',
			value: 'pe',
			imageUrl: Portail,
			nextStep: PortailData,
		},
		{
			id: 'pg',
			label: 'Porte de garage',
			value: 'pg',
			nextStep: PorteGarageData,
			imageUrl: Porte,
		},
	],
};

export default simulatorData;
